<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full mt-1" v-bind:src="loginState.user.companyLogo" 
          v-if="loginState.user && loginState.user.companyLogo" height="45" alt="Company Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto mr-3">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="authorizedNavItems"></SidebarNav>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view :key="$route.fullPath" ></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://preservetime.com">PreserveTime</a>
        <span class="ml-1">&copy; 2018 JellyHive.</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { globalStore, parseJwt } from "../shared/helpers";
import { userService } from "../shared/services";
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { log } from 'util'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      expiration: null
    }
  },
  methods: {
    isAuthorized(item) {
        if(item.role === 'User') return true;
        if(item.role === 'Auditor' && this.loginState.isAuditor) return true;
        if(item.role === 'Administrator' && this.loginState.isAdministrator) return true;
        if(item.role === 'SuperUser' && this.loginState.isSuperUser) return true;
    },
    checkExpiration() {
      if(!this.expiration) {
        var jwt = parseJwt(this.loginState.user.token);
        const expDate = new Date(0);
        expDate.setUTCSeconds(jwt.exp);
        this.expiration = expDate;
      }

      console.log(`Token expires: ${this.expiration}`);

      if(this.expiration < new Date()) {
        console.log(`Auth token expired, logging out`);
        this.loginState.logout();
        location.reload(true);
        return;
      }
      var seconds = Math.abs(((this.expiration - new Date())) / 1000);
      console.log(`${seconds} until expiration`);
      if(seconds < 900) {
        console.log(`Trying to refresh user and token`);
        userService.refreshUserAndToken()
        .then(() => {
          console.log(`User and token refreshed`);
        })
        .catch(p => {
          console.log(`An error '${JSON.stringify(p)}' occured while trying to refresh user and token`);
        }).finally(() => {
          this.expiration = null;
          setTimeout(this.checkExpiration, 300000)
        });
      }
      else{
        setTimeout(this.checkExpiration, 300000)
      }
    }
  },
  computed: {
    authorizedNavItems() {
      var self = this;
      var authorizedItems = nav.items.filter(function(item) {
        if(self.isAuthorized(item))
        {
          if(item.children) {
             item.children = item.children.filter(i => self.isAuthorized(i));
          }
          return item;
        }
      });

      return authorizedItems; 
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },

  },
  created() {
    this.loginState.init();
    this.checkExpiration();
  }, 

}
</script>
